var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline mt-2 text-primary",on:{"click":function($event){return _vm.resetAll()}}},[_c('a',{attrs:{"href":"javascript:void(0);"}},[_vm._v("Reset all")])])}
var staticRenderFns = []

export { render, staticRenderFns }